(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/gaming-blocked.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/gaming-blocked.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  returnUrl
} = svs.utils.url.queryString;
const {
  isPnp
} = svs.legal_info.data;
const {
  isPoker
} = svs.legal_info.data.loginCheckOptions.model;
const GamingBlocked = () => {
  const isNativeApp = Boolean(svs.core.config.data.svsconfig.isNativeApp);
  return React.createElement("section", {
    className: " f-content"
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "margin-top-1 margin-bottom-2 align-center"
  }, React.createElement(Icon, {
    color: isPnp ? 'fc-momang' : 'fc-red',
    icon: "pause",
    size: "1000"
  })), React.createElement("h1", {
    className: "align-center f-prominent"
  }, "Avst\xE4ngd fr\xE5n spel"), React.createElement("div", {
    className: "padding-xs-h-1"
  }, React.createElement("div", {
    className: "margin-top-1"
  }, "Du har st\xE4ngt av dig f\xF6r spel hos samtliga licensierade spelbolag i Sverige hos Spelinspektionen. Se", ' ', isPoker ? React.createElement("span", null, "www.spelpaus.se") : React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: "https://www.spelpaus.se",
    rel: isNativeApp ? undefined : 'noreferrer',
    target: isNativeApp ? undefined : '_blank'
  }, "www.spelpaus.se"), "."), React.createElement("div", {
    className: "grid-row gutter-xs-1 margin-top-2"
  }, isPoker ? React.createElement("div", {
    className: "col-xs-6 col-xs-offset-3"
  }, React.createElement(Button, {
    block: true,
    href: returnUrl,
    inverted: true
  }, "G\xE5 vidare")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    href: "/logga-ut",
    transparent: true
  }, "Logga ut")), React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    focus: !isPnp,
    href: returnUrl ? returnUrl : svs.core.urlMapping.get('startPage')
  }, "G\xE5 vidare")))), React.createElement("div", {
    className: "margin-top-2"
  }, "Har du fr\xE5gor? Kontakta", ' ', isPoker ? React.createElement("span", null, "Kundservice Svenska Spel Sport & Casino: 0770 - 11 11 11") : React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('customerServiceContact'),
    rel: "noreferrer",
    target: "_blank"
  }, "Kundservice Svenska Spel Sport & Casino")))));
};
svs.legal_info.components.login_check.self_exclusion_info.GamingBlocked = GamingBlocked;

 })(window);